import makeStyles from '@mui/styles/makeStyles'

export const useStyles = makeStyles(({ spacing }) => ({
  root: {
    width: '100%',
    padding: spacing(0, 3, 3)
  },
  ctnTitle: {
    marginBottom: spacing(5)
  },
  msaAccordion: {
    '&:before': {
      display: 'none'
    }
  },
  msaAccordionExpanded: {
    margin: '0 !important'
  },
  msaAccordionSummary: {
    height: 55,
    paddingLeft: '1.5rem',
    borderBottom: '1px solid rgba(0, 0, 0, 0.12)'
  },
  msaSubtitleMap: {
    fontSize: 14,
    fontWeight: 500,
    color: 'rgba(0, 0, 0, 0.6)'
  },
  msaScoreLabel: {
    fontSize: 12,
    paddingRight: 5,
    color: 'rgba(0, 0, 0, 0.6)'
  },
  msaScoreInput: {
    '& .MuiInputBase-root': {
      '& .MuiOutlinedInput-input': {
        padding: '10px 15px'
      }
    }
  }
}))
